import './FleetFive.css';
import AIheader from "../../RentAI/AIheader";
import Footer from "../../../Component/Footer/Footer";
import ScrollingAnounce from "../../../Component/GetAroundpage/ScrollingAnounce/ScrollingAnounce";
import EasySetup from "../../../Component/GetAroundpage/EasySetup/EasySetup";
import { useEffect, useState } from "react";
import { Accordion } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import FleetFiveSlide from '../../../Component/Fleet/FleetFiveSlide/FleetFiveSlide';

const FleetFive = ()=> {

     
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
          setTimeout(() => {
            const element = document.querySelector(hash);
            if (element) {
              const headerOffset = 80; // Adjust according to your header height
              const elementPosition = element.getBoundingClientRect().top + window.scrollY;
              window.scrollTo({
                top: elementPosition - headerOffset,
                behavior: "smooth",
              });
            }
          }, 100); // Delay to ensure DOM is loaded
        }
      }, []);
      

    useEffect(() => {
      setIsClient(true);
    }, []);
  
    if (!isClient) return null;
   


    return (
        <>
            <AIheader/>

            {/* START bannerFleetMain */}
            <section className="bannerFleetMain">
                <div className="container">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-lg-5">
                            <div className="bannerFleetLeft">
                                <h1>Empowering Fleets with<br/> <span>1-5 Vehicles</span></h1>
                                <h4>Establishing Your Rental Business</h4>
                                <p>Whether you’re renting out a single vehicle on a marketplace to friends 
                                    and neighbors or building a full-scale rental business, Rentid gives you 
                                    the flexibility to operate on your terms.</p>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="bannerFleetRight">
                                <figure>
                                    <img className='img-fluid' src="/img/Fleet/fleet_five_banner.png" alt="1-5 Vehicles"/>
                                </figure>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END bannerCarRentalMain */}
 
            <FleetFiveSlide/>

            {/* START gigDeliveryMain */}
            <section className='gigDeliveryMain gigFleetFiveMain'>
                <div className='container-fluid'>
                    <div className="row jusify-content-center align-items-center">
                        <div className="col-lg-6 col-md-12 col-sm-12 gx-0">
                            <div className="gigDeliveryLeft"> 
                                <h2>The first rental platform built for your growth</h2>
                                <p>As one of the few platforms offering full insurance for single-car 
                                rental businesses, Rentid makes it easy to enter the industry. 
                                Whether you have one vehicle or a growing fleet, our scalable 
                                insurance, automation, and operational tools help you focus on 
                                growth and profitability.</p>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12 col-sm-12 gx-0">
                            <div className="gigDeliveryRight" >
                                <img className='img-fluid' src="/img/Fleet/your_growth.png" alt="The first rental platform built for your growth"/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END gigDeliveryMain */}

            {/* START choiceFormerMain */}
            <section  className="choiceFormerMain choiceDesktopMain fleetFiveChoiceMain"> 
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div className="headChoiceFormer">
                                <h2>Rental Workflows & Tools Designed For Fleets</h2>
                                <p>The only rental platform you’ll ever need</p>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <ul className="nav nav-tabs main-tabs-ai">
                                <li className="nav-item">
                                    <a className="nav-link active" data-bs-toggle="tab" href="#choiceFormer_1">
                                        <img src="/img/AnoucementPage/rent_direct_icon.svg" alt="rent direct"/>rent<span>direct</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="tab" href="#choiceFormer_2">
                                        <img src="/img/AnoucementPage/rent_id_icon.svg" alt="rent id"/>rent<span>ID</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="tab" href="#choiceFormer_3">
                                        <img src="/img/AnoucementPage/rent_shield_icon.svg" alt="rent shield"/>rent<span>shield</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="tab" href="#choiceFormer_4">
                                        <img src="/img/AnoucementPage/rent_ai_icon.svg" alt="rent AI"/>rent<span>AI</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="tab" href="#choiceFormer_5">
                                        <img src="/img/AnoucementPage/rent_success_icon.svg" alt="rent success"/>rent<span>success</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="tab" href="#choiceFormer_6">
                                        <img src="/img/AnoucementPage/rent_academy_icon.svg" alt="rent academy"/>rent<span>academy</span>
                                    </a>
                                </li>
                            </ul>
                        
                            <div className="tab-content">
                                {/* START Tab 1 */}
                                <div className="tab-pane active" id="choiceFormer_1">
                                    <div className='row align-items-center'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentDirectLeft.png" alt="rent Direct"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerRight'>
                                                <div className='choiceFormerTop'>
                                                    <h3>Take Full Control of Your Rental Business</h3>
                                                    <h4>Enhance efficiency and increase revenue by automating routine processes.</h4>
                                                    <ul>
                                                        <li>
                                                            <h5>Flexible Booking Options</h5>
                                                            <small>Enable instant bookings or manual approvals to suit your business model.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Paperless Agreements</h5>
                                                            <small>Digital contracts streamline operations and eliminate paperwork.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Dynamic Fleet Calendar</h5>
                                                            <small>Set blackout dates, adjust pricing, and manage availability seamlessly.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Advanced Revenue Insights</h5>
                                                            <small>Monitor pricing trends, rental performance, and earnings at a glance.</small>
                                                        </li>
                                                    </ul>
                                                </div>        

                                                <div className='choiceFormerRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentdirect">Learn About RentDirect
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* END Tab 1 */}

                                {/* START Tab 2 */} 
                                <div className="tab-pane fade" id="choiceFormer_2">
                                    <div className='row align-items-center'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentIdLeft.png" alt="rent Id"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerRight'>
                                                <div className='choiceFormerTop'>
                                                    <h3>Smart Renter Verification & Fraud Prevention</h3>
                                                    <h4>Ensure every guest is verified and trustworthy with real-time risk assessment tools.</h4>
                                                    <ul>
                                                        <li>
                                                            <h5>DriverIQ™ Risk Scoring</h5>
                                                            <small>Evaluate renter reliability before approving a booking.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Automated ID & Insurance Verification</h5>
                                                            <small>Confirm guest credentials instantly.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Incident History Tracking</h5>
                                                            <small>Maintain renter profiles with past infractions and resolution history.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Fraud Detection Alerts</h5>
                                                            <small>Receive real-time notifications about potentially risky bookings.</small>
                                                        </li>
                                                    </ul>
                                                </div>                                           
                                                <div className='choiceFormerRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rent-id">Learn About RentID
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                {/* END Tab 2 */}

                                {/* START Tab 3 */}
                                <div className="tab-pane fade" id="choiceFormer_3">
                                    <div className='row align-items-center'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentShieldLeft.png" alt="rent shield"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerRight'>
                                                <div className='choiceFormerTop'>
                                                    <h3>Take Full Control of Your Rental Business</h3>
                                                    <h4>Enhance efficiency and increase revenue by automating routine processes.</h4>
                                                    <ul>
                                                        <li>
                                                            <h5>Flexible Booking Options</h5>
                                                            <small>Enable instant bookings or manual approvals to suit your business model.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Paperless Agreements</h5>
                                                            <small>Digital contracts streamline operations and eliminate paperwork.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Dynamic Fleet Calendar</h5>
                                                            <small>Set blackout dates, adjust pricing, and manage availability seamlessly.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Advanced Revenue Insights</h5>
                                                            <small>Monitor pricing trends, rental performance, and earnings at a glance.</small>
                                                        </li>
                                                    </ul>
                                                </div>                                           
                                                {/* <div className='choiceFormerRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentshield">Learn About RentShield
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                {/* END Tab 3 */}

                                {/* START Tab 4 */} 
                                <div className="tab-pane fade" id="choiceFormer_4">
                                    <div className='row align-items-center'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentAiLeft.png" alt="rent AI"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerRight'>
                                                <div className='choiceFormerTop'>
                                                    <h3>Take Full Control of Your Rental Business</h3>
                                                    <h4>Enhance efficiency and increase revenue by automating routine processes.</h4>
                                                    <ul>
                                                        <li>
                                                            <h5>Flexible Booking Options</h5>
                                                            <small>Enable instant bookings or manual approvals to suit your business model.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Paperless Agreements</h5>
                                                            <small>Digital contracts streamline operations and eliminate paperwork.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Dynamic Fleet Calendar</h5>
                                                            <small>Set blackout dates, adjust pricing, and manage availability seamlessly.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Advanced Revenue Insights</h5>
                                                            <small>Monitor pricing trends, rental performance, and earnings at a glance.</small>
                                                        </li>
                                                    </ul>
                                                </div>    
                                                {/* <div className='choiceFormerRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentai">Learn About RentAI
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                {/* END Tab 4 */}

                                {/* START Tab 5 */}
                                <div className="tab-pane fade" id="choiceFormer_5">
                                    <div className='row align-items-center'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentSuccessLeft.png" alt="rent success"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerRight'>
                                                <div className='choiceFormerTop'>
                                                    <h3>Take Full Control of Your Rental Business</h3>
                                                    <h4>Enhance efficiency and increase revenue by automating routine processes.</h4>
                                                    <ul>
                                                        <li>
                                                            <h5>Flexible Booking Options</h5>
                                                            <small>Enable instant bookings or manual approvals to suit your business model.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Paperless Agreements</h5>
                                                            <small>Digital contracts streamline operations and eliminate paperwork.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Dynamic Fleet Calendar</h5>
                                                            <small>Set blackout dates, adjust pricing, and manage availability seamlessly.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Advanced Revenue Insights</h5>
                                                            <small>Monitor pricing trends, rental performance, and earnings at a glance.</small>
                                                        </li>
                                                    </ul>
                                                </div>  
                                                {/* <div className='choiceFormerRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentsuccess">Learn About RentSuccess
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                {/* END Tab 5 */}


                                {/* START Tab 6 */} 
                                <div className="tab-pane fade" id="choiceFormer_6">
                                    <div className='row align-items-center'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentAcademyLeft.png" alt="rent Academy"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerRight'>
                                                <div className='choiceFormerTop'>
                                                    <h3>Take Full Control of Your Rental Business</h3>
                                                    <h4>Enhance efficiency and increase revenue by automating routine processes.</h4>
                                                    <ul>
                                                        <li>
                                                            <h5>Flexible Booking Options</h5>
                                                            <small>Enable instant bookings or manual approvals to suit your business model.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Paperless Agreements</h5>
                                                            <small>Digital contracts streamline operations and eliminate paperwork.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Dynamic Fleet Calendar</h5>
                                                            <small>Set blackout dates, adjust pricing, and manage availability seamlessly.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Advanced Revenue Insights</h5>
                                                            <small>Monitor pricing trends, rental performance, and earnings at a glance.</small>
                                                        </li>
                                                    </ul>
                                                </div>  
                                                {/* <div className='choiceFormerRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentacademy">Learn About RentAcademy
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                {/* END Tab 6 */}
                
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END choiceFormerMain */}

            {/* START choiceMobileMain */}
            <section  className="choiceFormerMain choiceMobileMain fleetFiveChoiceMain"> 
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div className="headChoiceFormer">
                                <h2>Single Platform for Loaners, Rentals & Customer Satisfaction</h2>
                                <p>The only rental platform you’ll ever need</p>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="choiceAccordian">
                            <Accordion defaultActiveKey="0">
                                {/* start 1 */}
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>
                                        <img src="/img/AnoucementPage/rent_direct_icon.svg" alt="rent id"/>rent<span>direct</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                    <div className='row'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceMobileLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentDirectLeft.png" alt="rent Direct"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceMobileRight'>
                                                <h3>Take Full Control of Your Rental Business</h3>
                                                <h4>Enhance efficiency and increase revenue by automating routine processes.</h4>
                                                <ul>
                                                    <li>
                                                        <h5>Flexible Booking Options</h5>
                                                        <small>Enable instant bookings or manual approvals to suit your business model.</small>
                                                    </li>
                                                    <li>
                                                        <h5>Paperless Agreements</h5>
                                                        <small>Digital contracts streamline operations and eliminate paperwork.</small>
                                                    </li>
                                                    <li>
                                                        <h5>Dynamic Fleet Calendar</h5>
                                                        <small>Set blackout dates, adjust pricing, and manage availability seamlessly.</small>
                                                    </li>
                                                    <li>
                                                        <h5>Advanced Revenue Insights</h5>
                                                        <small>Monitor pricing trends, rental performance, and earnings at a glance.</small>
                                                    </li>
                                                </ul>

                                                <div className='choiceMobileRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentdirect">Learn About RentDirect
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* start 2 */}
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>
                                        <img src="/img/AnoucementPage/rent_id_icon.svg" alt="rent id"/>rent<span>ID</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className='row'>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileLeft'>
                                                    <figure>
                                                        <img className="img-fluid" src="/img/AnoucementPage/rentIdLeft.png" alt="rentId"/>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileRight'> 
                                                    <h3>Smart Renter Verification & Fraud Prevention</h3>
                                                    <h4>Ensure every guest is verified and trustworthy with real-time risk assessment tools.</h4>
                                                    <ul>
                                                        <li>
                                                            <h5>DriverIQ™ Risk Scoring</h5>
                                                            <small>Evaluate renter reliability before approving a booking.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Automated ID & Insurance Verification</h5>
                                                            <small>Confirm guest credentials instantly.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Incident History Tracking</h5>
                                                            <small>Maintain renter profiles with past infractions and resolution history.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Fraud Detection Alerts</h5>
                                                            <small>Receive real-time notifications about potentially risky bookings.</small>
                                                        </li>
                                                    </ul>
                                                                                        
                                                    <div className='choiceMobileRightBtn'>
                                                        <a className="btn btnTransparent_4" href="/rent-id">Learn About RentID
                                                            <img src="/img/arrow_spl.svg" alt="icon"/>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* start 3 */}
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>
                                        <img src="/img/AnoucementPage/rent_shield_icon.svg" alt="rent id"/>rent<span>shield</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className='row'>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileLeft'>
                                                    <figure>
                                                        <img className="img-fluid" src="/img/AnoucementPage/rentShieldLeft.png" alt="rent shield"/>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileRight'>
                                                    <h3>Take Full Control of Your Rental Business</h3>
                                                    <h4>Enhance efficiency and increase revenue by automating routine processes.</h4>
                                                    <ul>
                                                        <li>
                                                            <h5>Flexible Booking Options</h5>
                                                            <small>Enable instant bookings or manual approvals to suit your business model.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Paperless Agreements</h5>
                                                            <small>Digital contracts streamline operations and eliminate paperwork.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Dynamic Fleet Calendar</h5>
                                                            <small>Set blackout dates, adjust pricing, and manage availability seamlessly.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Advanced Revenue Insights</h5>
                                                            <small>Monitor pricing trends, rental performance, and earnings at a glance.</small>
                                                        </li>
                                                    </ul>
                                                
                                                    {/* <div className='choiceMobileRightBtn'>
                                                        <a className="btn btnTransparent_4" href="/rentshield">Learn About RentShield
                                                            <img src="/img/arrow_spl.svg" alt="icon"/>
                                                        </a>
                                                    </div> */}
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* start 4 */}
                                <Accordion.Item eventKey="3">
                                    <Accordion.Header>
                                        <img src="/img/AnoucementPage/rent_ai_icon.svg" alt="rent id"/>rent<span>AI</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className='row'>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileLeft'>
                                                    <figure>
                                                        <img className="img-fluid" src="/img/AnoucementPage/rentAiLeft.png" alt="rent ai"/>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileRight'>
                                                    <h3>Take Full Control of Your Rental Business</h3>
                                                    <h4>Enhance efficiency and increase revenue by automating routine processes.</h4>
                                                    <ul>
                                                        <li>
                                                            <h5>Flexible Booking Options</h5>
                                                            <small>Enable instant bookings or manual approvals to suit your business model.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Paperless Agreements</h5>
                                                            <small>Digital contracts streamline operations and eliminate paperwork.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Dynamic Fleet Calendar</h5>
                                                            <small>Set blackout dates, adjust pricing, and manage availability seamlessly.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Advanced Revenue Insights</h5>
                                                            <small>Monitor pricing trends, rental performance, and earnings at a glance.</small>
                                                        </li>
                                                    </ul>
                                                    {/* <div className='choiceMobileRightBtn'>
                                                        <a className="btn btnTransparent_4" href="/rentai">Learn About RentAI
                                                            <img src="/img/arrow_spl.svg" alt="icon"/>
                                                        </a>
                                                    </div> */}
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* start 5 */}
                                <Accordion.Item eventKey="4">
                                    <Accordion.Header>
                                        <img src="/img/AnoucementPage/rent_success_icon.svg" alt="rent id"/>rent<span>success</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                    <div className='row'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceMobileLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentSuccessLeft.png" alt="rent success"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceMobileRight'> 
                                                    <h3>Take Full Control of Your Rental Business</h3>
                                                    <h4>Enhance efficiency and increase revenue by automating routine processes.</h4>
                                                    <ul>
                                                        <li>
                                                            <h5>Flexible Booking Options</h5>
                                                            <small>Enable instant bookings or manual approvals to suit your business model.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Paperless Agreements</h5>
                                                            <small>Digital contracts streamline operations and eliminate paperwork.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Dynamic Fleet Calendar</h5>
                                                            <small>Set blackout dates, adjust pricing, and manage availability seamlessly.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Advanced Revenue Insights</h5>
                                                            <small>Monitor pricing trends, rental performance, and earnings at a glance.</small>
                                                        </li>
                                                    </ul>
                                        
                                                {/* <div className='choiceMobileRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentsuccess">Learn About RentSuccess
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* start 6 */}
                                <Accordion.Item eventKey="5">
                                    <Accordion.Header>
                                        <img src="/img/AnoucementPage/rent_academy_icon.svg" alt="rent id"/>rent<span>academy</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className='row'>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileLeft'>
                                                    <figure>
                                                        <img className="img-fluid" src="/img/AnoucementPage/rentAcademyLeft.png" alt="rentAcademy"/>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileRight'> 
                                                    <h3>Take Full Control of Your Rental Business</h3>
                                                    <h4>Enhance efficiency and increase revenue by automating routine processes.</h4>
                                                    <ul>
                                                        <li>
                                                            <h5>Flexible Booking Options</h5>
                                                            <small>Enable instant bookings or manual approvals to suit your business model.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Paperless Agreements</h5>
                                                            <small>Digital contracts streamline operations and eliminate paperwork.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Dynamic Fleet Calendar</h5>
                                                            <small>Set blackout dates, adjust pricing, and manage availability seamlessly.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Advanced Revenue Insights</h5>
                                                            <small>Monitor pricing trends, rental performance, and earnings at a glance.</small>
                                                        </li>
                                                    </ul>
                                
                                                        {/* <div className='choiceMobileRightBtn'>
                                                            <a className="btn btnTransparent_4" href="/rentacademy">Learn About RentAcademy
                                                                <img src="/img/arrow_spl.svg" alt="icon"/>
                                                            </a>
                                                        </div> */}
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                                {/* end 6 */}
                            </Accordion>
                        </div>
                    </div>
                </div>
            </section>
            {/* END choiceMobileMain */}


            {/* START industryFleetFiveMain */}
            <section className='industryFleetFiveMain'>
                <div className='container'>
                    <div className='row align-items-center'>
                        <div className='col-lg-12 col-md-12 col-sm-12'>
                            <div className='industryFleetFiveHead'>
                                <h6>INDUSTRY SOLUTIONS</h6>
                                <h2>Solving Car Rental for Everyone</h2>
                                <p>Rentid makes car rental easy and simple for everyone, no matter your industry. 
                                Optimize every rental with a powerful, all-in-one back-office solution. Automate 
                                workflows, simplify management, and resolve issues seamlessly—so you can 
                                grow your business.</p>
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="/car-rental">
                                    <img className='img-fluid' src="/img/Fleet/car_black.svg" alt="Car Rental"/>
                                    <h3>Car Rental</h3>
                                </a>
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="/car-sharing">
                                    <img className='img-fluid' src="/img/Fleet/refresh_black.svg" alt="Car Sharing"/>
                                    <h3>Car Sharing</h3>
                                </a>
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                            <a href="/ride-sharing">
                                <img className='img-fluid' src="/img/Fleet/user_switch_black.svg" alt="Ride Share"/>
                                <h3>Ride Share</h3>
                            </a>
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="/delivery">
                                    <img className='img-fluid' src="/img/Fleet/spoon_black.svg" alt="Delivery Drivers"/>
                                    <h3>Delivery Drivers</h3>
                                </a>
                            </div>
                        </div>

                        {/* START 2 */}
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="/auto-dealerships">
                                    <img className='img-fluid' src="/img/Fleet/car_parking_black.svg" alt="Auto Dealerships"/>
                                    <h3>Auto Dealerships</h3>
                                </a>
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="/service-repair">
                                    <img className='img-fluid' src="/img/Fleet/wrench_black.svg" alt="Service & Repair"/>
                                    <h3>Service & Repair</h3>
                                </a>
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="/vacation-rental">
                                    <img className='img-fluid' src="/img/Fleet/house_black.svg" alt="Vacation Rental"/>
                                    <h3>Vacation Rental</h3>
                                </a>
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="#">
                                    <img className='img-fluid' src="/img/Fleet/hotel_black.svg" alt="Hotel & Resort"/>
                                    <h3>Hotel & Resort</h3>
                                </a>
                            </div>
                        </div>

                        {/* START 3 */}
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="#">
                                    <img className='img-fluid' src="/img/Fleet/building_black.svg" alt="Property Mgmt"/>
                                    <h3>Property Mgmt</h3>
                                </a>
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="#">
                                    <img className='img-fluid' src="/img/Fleet/tie_black.svg" alt="Corporate"/>
                                    <h3>Corporate</h3>
                                </a>
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="#">
                                    <img className='img-fluid' src="/img/Fleet/pentagon_black.svg" alt="Government"/>
                                    <h3>Government</h3>
                                </a>
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="#">
                                    <img className='img-fluid' src="/img/Fleet/teacher_black.svg" alt="Education"/>
                                    <h3>Education</h3>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END industryFleetFiveMain */}

            {/* START industryTrustMain */}
            <section className="industryTrustMain">
                <div className="container">
                    <div className='industryTrustOuter'>
                        <div className='row align-items-center'>
                            <div className='col-lg-5 col-md-12 col-sm-12 col-12'>
                                <div className='industryTrustLeft'>
                                    <h2>Industry trust<span> and transparency</span> </h2>
                                </div>
                            </div>
                            <div className='col-lg-7 col-md-12 col-sm-12 col-12'>
                                <div className='industryTrustRight'>
                                    <ul>
                                        <li>
                                            <img className="img-fluid" width="140px" src="/img/AnoucementPage/industryTrust_1.png" alt="Industry trust and transparency" />
                                        </li>
                                        <li>
                                            <img className="img-fluid" width="164px" src="/img/AnoucementPage/industryTrust_2.png" alt="Industry trust and transparency" />
                                        </li>
                                        <li>
                                            <img className="img-fluid" width="146px" src="/img/AnoucementPage/industryTrust_3.png" alt="Industry trust and transparency" />
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END industryTrustMain */}
             
            <EasySetup/> 

            {/* START expSolutionsMain */}
            <section className="expSolutionsMain">
                <div className="container">
                    <div className='expSolutionsOuter'>
                        <div className='row align-items-center'>
                            <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                                <div className='expSolutionsInner'>
                                    <h2>Explore Solutions for<br/> Fleets with 6-25 Vehicles</h2>
                                    <a className="btn btnWhite" href="/fleet-25">Explore</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END expSolutionsMain */}

            <ScrollingAnounce/>
            <Footer/>
        </>
    )
}

export default FleetFive;